interface MetaTagsProps {
    title: string;
    description: string;
    image?: string;
    url?: string;
    published?: string;
    modified?: string;
}

function absoluteUrl(path?: string) {
    const origin = typeof window !== "undefined" ? window.location.origin : "https://www.kosmos.com.na";
    if (!path) return origin;
    if (path.startsWith("http://") || path.startsWith("https://")) return path;
    return `${origin}${path.startsWith("/") ? path : `/${path}`}`;
}

export function MetaTags({
                             title,
                             description,
                             image,
                             url,
                             published,
                             modified
                         }: MetaTagsProps) {

    const SITE_NAME = "Kosmos 94.1";
    const DEFAULT_IMAGE = "https://www.kosmos.com.na/logo_main.jpeg";

    const jsonLd = {
        "@context": "https://schema.org",
        "@type": "NewsArticle",
        headline: title,
        description: description,
        image: [image],
        datePublished: published,
        dateModified: modified,
        publisher: {
            "@type": "Organization",
            name: SITE_NAME,
            logo: {"@type": "ImageObject", url: image ?? DEFAULT_IMAGE},
        },
        mainEntityOfPage: {"@type": "WebPage", "@id": absoluteUrl(url)},
    };

    return (
        <>
            <title>{title}</title>
            <link rel="canonical" href={url ?? window.location.href}/>

            <meta name="description" content={description}/>

            <meta property="og:site_name" content={SITE_NAME}/>
            <meta property="og:title" content={title}/>
            <meta property="og:description" content={description}/>
            <meta property="og:url" content={absoluteUrl(url)}/>
            <meta property="og:image" content={image ?? DEFAULT_IMAGE}/>
            <meta property="og:type" content={published ? "article" : "website"}/>
            {published && <meta property="article:published_time" content={published}/>}
            {modified && <meta property="article:modified_time" content={modified}/>}

            <meta name="twitter:card" content={image ? "summary_large_image" : "summary"}/>
            <meta name="twitter:title" content={title}/>
            <meta name="twitter:description" content={description}/>
            {image && <meta name="twitter:image" content={image}/>}

            <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
        </>
    );
}
